import React from "react";
import { Menu, Badge, Spin } from "antd";

import {
  UserOutlined,
  ExperimentOutlined,
  ProfileOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useLocation, NavLink } from "react-router-dom";
import ordersApi from "Api/orders";
import { useAuthState } from "Contexts/Auth";
import userType from "Types/userType";

const { SubMenu } = Menu;

// const linkRegex = new RegExp(/^(\/[\w\d]+)/);
// const linkToKey = (link: string) => link.match(linkRegex)?.shift();
// const isLinkMatchToKey = (link: string, key: string) => linkToKey(link) === key;
const isLocationkMatchToKey = (loc: string, key: string) =>
  loc.indexOf(key) === 0;

const Siderbar = () => {
  const { role } = useAuthState();
  const { data, isLoading } = ordersApi[
    role === "Director" ? "useAdminWaited" : "useLabWaited"
  ]();
  const loc = useLocation();
  const checkHasRole = (requiredRoles: userType["role"][]): boolean =>
    !!requiredRoles.find((r) => r === role);

  const items: {
    title: string;
    icon: React.ReactNode;
    requiredRoles?: userType["role"][];
    menuItems: {
      name: string;
      to: string;
      badge?: number;
      loading?: boolean;
      requiredRoles?: userType["role"][];
    }[];
  }[] = [
    {
      title: "مواد شیمیایی",
      icon: <ExperimentOutlined />,
      menuItems: [
        {
          name: "لیست مواد",
          to: "/chemicals/list",
        },
        {
          name: "افزودن ماده جدید",
          to: "/chemicals/addEdit",
          requiredRoles: ["Director", "Laboratory"],
        },
        {
          name: "مدیریت واحدها",
          to: "/units",
          requiredRoles: ["Director", "Laboratory"],
        },
      ],
    },
    {
      title: "کاربران",
      icon: <UserOutlined />,
      requiredRoles: ["Director"],
      menuItems: [
        {
          name: "لیست کاربران",
          to: "/users/list",
        },
        {
          name: "افزودن کاربر جدید",
          to: "/users/addEdit",
        },
      ],
    },
    {
      title: "درخواست ها",
      icon: <ProfileOutlined />,
      menuItems: [
        {
          name: role === "Professor" ? "همه درخواست ها" : "درخواست های جدید",
          to: role === "Professor" ? "/orders/all" : "/orders/waiting",
          badge: role === "Professor" ? undefined : data?.length || undefined,
          loading: role !== "Professor" && isLoading,
        },
        {
          name: "درخواست های تایید شده",
          to: "/orders/approved",
        },
        {
          name: "درخواست های رد شده",
          to: "/orders/rejected",
        },
      ],
    },
  ];

  const selectedKeys = [
    items
      .map((item) => item.menuItems)
      .flat()
      .find((item) => isLocationkMatchToKey(loc.pathname, item.to))?.to || "",
  ];
  const openKeys = [
    items.find((item) =>
      item.menuItems.find((menuItem) =>
        isLocationkMatchToKey(loc.pathname, menuItem.to)
      )
    )?.title || "",
  ];
  return (
    <Menu
      mode="inline"
      selectedKeys={selectedKeys}
      defaultOpenKeys={openKeys}
      style={{ height: "100%" }}
    >
      {items
        .filter(
          (item) => !item.requiredRoles || checkHasRole(item.requiredRoles)
        )
        .map((item) => (
          <SubMenu icon={item.icon} title={item.title} key={item.title}>
            {item.menuItems
              .filter(
                (menuItem) =>
                  !menuItem.requiredRoles ||
                  checkHasRole(menuItem.requiredRoles)
              )
              .map((menuItem) => (
                <Menu.Item key={menuItem.to}>
                  <NavLink to={menuItem.to}>
                    {menuItem.name}{" "}
                    {menuItem.loading ? (
                      <Spin
                        indicator={
                          <LoadingOutlined style={{ fontSize: 24 }} spin />
                        }
                      />
                    ) : (
                      menuItem.badge && <Badge count={menuItem.badge} />
                    )}
                  </NavLink>
                </Menu.Item>
              ))}
          </SubMenu>
        ))}
      <p style={{ margin: "3rem 1rem", lineHeight: "1.2rem" }}>
        {` با توجه به اینکه در روز های شنبه و سه شنبه هر هفته مواد درخواستی از
        انبار به بخش منتقل می گردد. لذا خواهشمند است پس از ثبت درخواست، ظرف
        مناسب ( با توجه به مقدار درخواستی ) را قبل از ساعت 10:30 روزهای ذکر شده
        تحویل مسئول انبار( واقع در طبقه دوم اتاق شماره D-206) فرمایید. با سپاس و
        قدردانی`}
      </p>
    </Menu>
  );
};

export default Siderbar;
